import IconButton from '@/global/components/Button/IconButton'
import { Link } from '@/global/components/Link'
import Menu from '@/global/components/Menu'
import { LockIcon } from 'lucide-react'

export default function IconeCadeado() {
    return (
        <Menu.Root arrow>
            <Menu.Trigger>
                <IconButton>
                    <LockIcon className="text-error" />
                </IconButton>
            </Menu.Trigger>
            <Menu.Popover className="p-4 w-max max-w-sm">
                Período fechado, para editar ou excluir será necessário
                <Link href="/manutencao-ponto/fechamento-competencia">
                    &nbsp;reabrir a competência&nbsp;
                </Link>
                em que a ausência foi lançada.
            </Menu.Popover>
        </Menu.Root>
    )
}
